module.exports = __webpack_public_path__ + "img/logo.a8c12ea4.svg";